import { useTableDataRangeStore } from "@/store/table.data.range";
import { TableIds, useTableStore } from "@/store/tables";
import { useParams } from "react-router-dom";
import { useToggleStore } from "@/store/toggles";

interface IUseCommersCardProps {
  TableId: TableIds;
}

export const useCommersCardProps = ({ TableId }: IUseCommersCardProps) => {
  const { id } = useParams<{ id: string }>();
  const productId = Number(id);
  const dateRange = useTableDataRangeStore((store) => store.dateRange);
  const isSidebarVisible = useToggleStore((state) => state.isSidebarVisible);
  const { getTableSettings } = useTableStore();
  const savedSettings = getTableSettings(TableId);
  return { productId, dateRange, isSidebarVisible, savedSettings };
};
